<mat-card appearance="outlined">
  <mat-card-header class="card-header">
    <mat-card-title>
      {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.PHOTOS' | translate }}
    </mat-card-title>
    @if (!editDisabled()) {
      <button mat-stroked-button class="add-button" color="primary" type="button" (click)="openImageUploadDialog()">
        <mat-icon class="">add_a_photo</mat-icon>
        {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.ADD_PHOTOS' | translate }}
      </button>
    }
  </mat-card-header>
  <mat-card-content layout="column" layout-align="center center" class="image-gallery-card">
    <br />
    @if (images$ | async; as images) {
      @if (galleryInfo$ | async; as info) {
        <business-media-tab-gallery
          [images]="images"
          (imageClicked)="openLightbox($event)"
          (menuOptionSelected)="imageMenuClicked($event)"
        ></business-media-tab-gallery>
        @if (info.loading) {
          <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
        }
        @if (info.pageFetchError) {
          <div class="connection-error">
            <span>
              {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.UNABLE_TO_LOAD_IMAGES' | translate }}
            </span>
          </div>
        }
        @if (info.hasMore) {
          <div class="load-more-button">
            <button mat-button type="button" [disabled]="info.loading" (click)="loadMore()">
              {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.LOAD_MORE' | translate }}
            </button>
          </div>
        }
        <div class="result-count">
          <span>
            {{
              'FRONTEND.BUSINESSES.MEDIA_TAB.SHOWING_X_OF_Y'
                | translate: { count: images.length, total: info.totalImages }
            }}
          </span>
        </div>
      }
    } @else {
      <span class="no-images-section">
        <i class="material-icons upload" color="gray">collections</i>
        <br />
        <label>
          {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.ADD_PHOTOS' | translate }}
        </label>
        <br />
        <div>
          {{ 'FRONTEND.BUSINESSES.MEDIA_TAB.ADDING_IMAGES_BOLSTERS' | translate }}
        </div>
      </span>
    }
  </mat-card-content>
</mat-card>
